import { render, staticRenderFns } from "./Posts1.vue?vue&type=template&id=2b4cdb92&scoped=true&"
import script from "./Posts1.vue?vue&type=script&lang=js&"
export * from "./Posts1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4cdb92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Attivita\\SVILUPPO Laravel\\archilogy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4cdb92')) {
      api.createRecord('2b4cdb92', component.options)
    } else {
      api.reload('2b4cdb92', component.options)
    }
    module.hot.accept("./Posts1.vue?vue&type=template&id=2b4cdb92&scoped=true&", function () {
      api.rerender('2b4cdb92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Post/Posts1.vue"
export default component.exports